module.exports = __webpack_public_path__ + "static/screen-572d0385addb6d888ac51bcb9a482c34.png";